import { createAsyncThunk } from "@reduxjs/toolkit"

import apiClient from "src/apiClient"
import { basicTrainingPendingFrom } from "src/utils/training"

import userReducers from "../reducers"

/* This account has been walked into basic training: say so on the row.

   Sent by the tutorial view the moment it opens for an account still marked pending, and never
   otherwise — a replay from the manual has nothing to record. The answer is the user with the
   column set, read back into the slice so the automatic start (`routes.js`) stops firing without
   waiting for the next `/users/me/`. */
export const thunk = createAsyncThunk("user/markBasicTrainingSeen", async (_, { rejectWithValue }) => {
  try {
    const response = await apiClient.post("/users/me/basic-training/")
    return { basicTrainingPending: basicTrainingPendingFrom(response.data) }
  } catch (error) {
    return rejectWithValue(error.response?.data || { detail: "Could not reach the server." })
  }
})

export const onSucceed = userReducers.setData

const thunkObject = { thunk, onSucceed }
export default thunkObject
